import { formatarComoDecimal, formatarComoMoeda, parseLocaleNumber } from "../../contents/VariaveisGlobais";
import { handleFilaAprovadores } from "./Pedido";
import { handleAbrirPC } from "./Solicitacao";
import { CelBreak25, NormalFont } from "./styles";

function handleFilialMedicao(item, DisparaBootBox, FechaBootBox, navigate){
    const { CND_NUMMED, CNE_PEDIDO, EMPRESA, CND_FILIAL } = item.row.original;
    const chaveSCR = CND_NUMMED
    
    return (
        <>
            <NormalFont tooltipText={"Fila de Aprovadores"} onClick={(e)=> handleFilaAprovadores("MD','IM", chaveSCR, EMPRESA, CND_FILIAL, DisparaBootBox, FechaBootBox)}><strong>Fil.: </strong>{CND_FILIAL}</NormalFont>
            <br/><NormalFont><strong>Medição: </strong>{CND_NUMMED}</NormalFont>
            <br/><NormalFont><strong>PC: </strong>{CNE_PEDIDO}</NormalFont>
        </>
    )
}

function handleFornecedorMedicao(item, DisparaBootBox, FechaBootBox, navigate){
    const { CXN_FORNEC, CXN_LJFORN, A2_NOME, CND_CONTRA, CND_REVISA, CNE_CC, CTT_DESC01 } = item.row.original;
    
    return (
        <div>
            <div>{CXN_FORNEC}/{CXN_LJFORN} - {A2_NOME}</div>
            <div><strong>Contrato:</strong> {CND_CONTRA} {CND_REVISA && CND_REVISA.trim() ? ` - ${CND_REVISA}` : ''}</div>
            <div><strong>CC:</strong> {CNE_CC} - {CTT_DESC01}</div>
        </div>
    )
}

function handleTotalMedicao(item, DisparaBootBox, FechaBootBox, navigate){
    const { TOTAL_CC, TOTAL_MEDICAO } = item.row.original;
    
    return (
        <div>
            <div><strong>Total C.Custo:</strong> {formatarComoMoeda(TOTAL_CC)}</div>
            <div><strong>Total Medição:</strong> {formatarComoMoeda(TOTAL_MEDICAO)}</div>
        </div>
    )
}

export { handleFilialMedicao, handleFornecedorMedicao, handleTotalMedicao }